import React from 'react';

class Header extends React.Component {
	constructor() {
		super();
		this.isActive = this.isActive.bind(this);
	}
	isActive(tab, location) {
			return location === tab ? 'active' : '';
	}
	render(){
		const location = window.location.pathname;
	return (
		<header className="top">
			<h1 className="pageName">Benjamin Gummelt</h1>
			<ul className="nav">
				<li><a href="/" className={this.isActive('/', location)}>Home</a></li>
				<li><a href="/about" className={this.isActive('/about', location)}>About</a></li>
				<li><a href="/contact" className={this.isActive('/contact', location)}>Contact</a></li>
			</ul>
		</header>
	)
	}
}

export default Header;


/** WEBPACK FOOTER **
 ** ./src/components/Header.js
 **/